import { render, staticRenderFns } from "./services.vue?vue&type=template&id=323435fa&"
import script from "./services.vue?vue&type=script&lang=js&"
export * from "./services.vue?vue&type=script&lang=js&"
import style0 from "./services.vue?vue&type=style&index=0&id=323435fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseOrnamentBg: require('/opt/airport.kg/src/components/base/ornament-bg.vue').default,ServiceImageCard: require('/opt/airport.kg/src/components/service/image-card.vue').default,RzButton: require('/opt/airport.kg/node_modules/razlet-ui/src/components/button/index.js').default,RzContainer: require('/opt/airport.kg/node_modules/razlet-ui/src/components/container/index.vue').default})
